export const navItems = [
	{
		title: "API",
		link: "/api/general/introduction",
		activePrefix: "/api",
		isExternal: false,
	},
	{
		title: "DOCUMENTATION",
		link: "/documentation/general/home",
		activePrefix: "/documentation",
		isExternal: false,
	},
	{
		title: "Change Log",
		link: "https://feedback.vatom.com/changelog?labels=developer-portal",
		activePrefix: "/",
		isExternal: true,
	},
	{
		title: "Forum",
		link: "https://support.vatom.com/hc/en-us/community/topics/8138075849371-Developers",
		activePrefix: "/",
		isExternal: true,
	},
];

export const bentoMenuItems = [
	{
		url: "https://market.vatom.com/",
		icon: "market-icon.svg",
		title: "Market",
	},
	{
		url: "https://www.spatialweb.net/",
		icon: "spaces-icon.svg",
		title: "Spaces",
	},
	{
		url: "https://studio.vatominc.com/",
		icon: "studio-icon.svg",
		title: "Studio",
	},
	{
		url: "https://wallet.vatom.com/",
		icon: "wallet-icon.svg",
		title: "Wallet",
	},
];
